document.addEventListener('DOMContentLoaded', function () {

  const preLaunchButton = document.querySelector('.js-klaviyo-pre-launch');

  if (preLaunchButton) {

    preLaunchButton.addEventListener('click', function (e) {
      e.preventDefault();

      const klaviyoFormID = preLaunchButton.dataset.klaviyoFormId;

      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', klaviyoFormID]);
    });
  }

}, false);